import { useState } from "react";
import Sidebar from "@/pages/sidebar/sidebar";
import ClientMainHeader from "@/pages/header";
import { MainWrapper } from "@/pages/styled";
import { LimitedAccountWarning } from "@/components/limited-account-warning";
import { MerchantProcessingBanner } from "@/components/merchant-processing-banner";
import PayablesTable from "@/components/invoices/payables-table";

const PayBills = () => {
  const [currentWidth, setCurrentWidth] = useState(0);

  return (
    <div className="h-100">
      <Sidebar currentWidth={currentWidth} setCurrentWidth={setCurrentWidth} />
      <>
        <LimitedAccountWarning />
        <MerchantProcessingBanner />

        <MainWrapper>
          <ClientMainHeader title="Pay Bills" />
          <PayablesTable />
        </MainWrapper>
      </>
    </div>
  );
};

export default PayBills;
